import React from 'react';
import { Button } from 'src/components/common/Button';
import { media } from 'src/styles/designs';
import styled from 'styled-components';
import { useTranslate } from 'react-t7e';
import { DispatchOnClick } from 'src/components/common/DispatchOnClick';

const StyledButton = styled(Button).attrs({ forwardedAs: 'a' })`
  ${media.w.greaterThanOrEqual.desktop} {
    max-width: 194px;
  }
`;

export const AboutUsContactButton = () => {
  const { _ } = useTranslate();

  return (
    <DispatchOnClick type="modalOpen" payload={{ kind: 'contact' }}>
      <StyledButton>{_('Contact us')}</StyledButton>
    </DispatchOnClick>
  );
};
